import { Modal, Button } from 'react-bootstrap';
import { TriggerRexmTableWrapper } from '../styles';

interface IProps {
    show: boolean,
    donorAlias: string,
    donorCenter: string,
    recipientAlias: string,
    recipientCenter: string,
    onYes: () => void,
    onNo: () => void
}

const TriggerRexm = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>REXM Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>Are you sure you want to trigger an REXM email for the following?</div>
                <div style={{ marginTop: 15, marginLeft: 10 }}>
                    <TriggerRexmTableWrapper className='table table-bordered table-condensed'>
                        <thead>
                            <tr>
                                <th colSpan={2} style={{ textAlign: 'center' }}>Donor</th>
                                <th colSpan={2} style={{ textAlign: 'center' }}>Recipient</th>
                            </tr>
                            <tr>
                                <th>Alias</th>
                                <th>Center</th>
                                <th>Alias</th>
                                <th>Center</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{props.donorAlias}</td>
                                <td>{props.donorCenter}</td>
                                <td>{props.recipientAlias}</td>
                                <td>{props.recipientCenter}</td>
                            </tr>
                        </tbody>
                    </TriggerRexmTableWrapper>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes</Button>
                <Button onClick={props.onNo}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TriggerRexm;